var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/contentful/render-entry.j2"] = require( "macros/contentful/render-entry.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/shipping/pdp-flat-rate-returns.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/contentful/render-entry.j2", false, "product/templates/shipping/pdp-flat-rate-returns.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("renderEntry")) {
var t_4 = t_1.renderEntry;
} else {
cb(new Error("cannot import 'renderEntry'")); return;
}
context.setVariable("renderEntry", t_4);
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"shippingModules")),"product_returns-flat-rate")) {
var t_5;
t_5 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"shippingModules")),"product_returns-flat-rate");
frame.set("entry", t_5, true);
if(frame.topLevel) {
context.setVariable("entry", t_5);
}
if(frame.topLevel) {
context.addExport("entry", t_5);
}
output += "\n    ";
output += runtime.suppressValue((lineno = 5, colno = 16, runtime.callWrap(t_4, "renderEntry", context, [runtime.contextOrFrameLookup(context, frame, "entry")])), env.opts.autoescape);
;
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/shipping/pdp-flat-rate-returns.j2"] , dependencies)